import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'blog_gated_content-brandblogformsubmissionover25stockists-action_unknown';

/**
 * Emit facebook event when BrandBlogContentFormSubmission event is fired and number of stockists is greater than 25
 */
export function trackBlogGatedContentBrandblogformsubmissionover25Stockists(
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent:
      'ifBrandBlogContentFormSubmissionGreaterThan25Stockists',
    pixelCustomDataParams,
  });
}
